import { KeyValueWithFieldItem } from '@/application/utils/types';
import { ChartSelectedLabel } from '@/common/utils';

export const ELAPSE_RATIO_COLORS = [
  'var(--elapse-ratio-app-color)',
  'var(--elapse-ratio-sql-color)',
  'var(--elapse-ratio-remote-color)',
];

export const PATH_COLOR = {
  HIGHLIGHT_COLOR: '#ef4444',
  STROKE_DARK: '#a2a2a2',
  STROKE_LIGHT: '#80868f',
};

export const BASE_DETAILS: KeyValueWithFieldItem[] = [
  { key: 'Transaction Status', field: 'txnStatus', value: '' },
  { key: 'End Time', field: 'endTime', value: '' },
  { key: 'Thread ID', field: 'threadId', value: '' },
  { key: 'TID', field: 'tid', value: '' },
  { key: 'State', field: 'state', value: '' },
  { key: 'Class Method', field: 'classMethod', value: '' },
  { key: 'Method Type', field: 'methodType', value: '' },
  { key: 'Start Time', field: 'startTime', value: '' },
  { key: 'Client IP', field: 'clientIp', value: '' },
  { key: 'Client Type', field: 'clientType', value: '' },
  { key: 'Login Name', field: 'loginName', value: '' },
  { key: 'Total Elapsed Time', field: 'elapsedTime', value: '' },
  { key: 'Prepare Count', field: 'prepareCount', value: '' },
  { key: 'Fetch Count', field: 'fetchCount', value: '' },
  { key: 'Total Memory Used', field: 'threadMemoryUsage', value: '' },
  { key: 'Total CPU Time', field: 'cpuTime', value: '' },
  { key: 'Total SQL Elapsed Time', field: 'sqlElapsedTime', value: '' },
  { key: 'SQL Execution Count', field: 'sqlExecCount', value: '' },
  { key: 'DB Instance', field: 'dbName', value: '' },
  { key: 'SID', field: 'sid', value: '' },
];

export const BASE_REMOTES: KeyValueWithFieldItem[] = [
  { key: 'Total Remote Time', field: 'remoteElapsedTime', value: '' },
  { key: 'Remote Count', field: 'remoteCount', value: '' },
  { key: 'Current Remote Time', field: 'currentRemoteElapsedTime', value: '' },
  { key: 'Outbound Type', field: 'outboundType', value: '' },
  { key: 'Destination URL', field: 'destinationURL', value: '' },
];

export const BASE_STACKTRACE: KeyValueWithFieldItem[] = [
  { key: 'Last Stack Time', field: 'collectTime', value: '' },
];

export const TRANSACTION_LINK_FIELDS = {
  TID: 'tid',
  DB_NAME: 'dbName',
};

export const WEB_SERVER_DETAILS: KeyValueWithFieldItem[] = [
  { key: 'Request Name (URI)', field: 'url', value: '' },
  { key: 'Web TID', field: 'tid', value: '' },
  { key: 'Method Type', field: 'methodType', value: '' },
  { key: 'Start Time', field: 'startTime', value: '' },
  { key: 'Active Time', field: 'activeTime', value: '' },
  { key: 'Client IP', field: 'clientIp', value: '' },
  { key: 'Port', field: 'port', value: '' },
  { key: 'Request Size', field: 'requestSize', value: '' },
  { key: 'HTTP Protocol', field: 'httpProtocol', value: '' },
  { key: 'Destination URL ', field: 'destinationUrl', value: '' },
];

export const WAS_TYPES = ['java', 'python', 'dotnet', 'dotnet_framework', 'nodejs'] as const;

export const TXN_TYPES = {
  WSM: 'wsm',
  WAS: 'was',
  DB: 'db',
} as const;

export const TOP_SUMMARY_MAX_TOP_NUMBER = 2_000;
export const TOP_SUMMARY_MIN_TOP_NUMBER = 1;

export const DISPLAY_INFO = {
  CHART: 'CHART',
  GRID: 'GRID',
} as const;

export const DEFAULT_SELECTED_CHART_LABEL: ChartSelectedLabel = {
  dataIndex: [],
  targetAxis: 'xAxis',
};

export const TRANSACTION_DEFAULT_ICON_CLASS = {
  base: 'icon-desktop',
  database: 'icon-db-fill',
};

export const TRANSACTION_TREND_ROW_COUNT_PER_REQUEST = 1_000; // api 호출 시 조회할 데이터 갯수
export const TRANSACTION_TREND_ROW_MAX = 100_000;

/**
 * Application Transaction Scatter 차트의 Y축 최대값 최소값 (ms)
 * 데이터의 최대 응답시간이 해당 값보다 작으면 고정 범위 [0, 해당 값]을 사용하고,
 * 그렇지 않으면 자동 스케일을 적용합니다.
 */
export const APPLICATION_Y_MIN_VALUE = 1_000;

export const TRANSACTION_SERIES_COLOR = {
  NORMAL: '#198FFF',
  EXCEPTION: '#FF1F3F',
} as const;

export const APPLICATION_TRANSACTION_TARGET_TIME_RANGE_SECONDS = 5;
